import React from 'react';
import googleIcon from '../assets/google-icon.svg';

const GooglePopupOverlay = ({ show }) => {
    if (!show) return null;

    return (
        <div
            style={{
                position: 'fixed',
                inset: 0,
                backgroundColor: 'rgba(0,0,0,0.6)',
                zIndex: 9999,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
            }}
        >
            <div
                style={{
                    backgroundColor: '#fff',
                    borderRadius: '12px',
                    padding: '32px 28px',
                    maxWidth: '360px',
                    width: '90%',
                    textAlign: 'center',
                    boxShadow: '0 20px 60px rgba(0,0,0,0.2)',
                }}
            >
                <div className="mb-3">
                    <img src={googleIcon} alt="Google" style={{ width: '40px' }} />
                </div>
                <h6 className="fw-bold mb-2">Don't be confused by this screen!</h6>
                <p className="text-muted small mb-3">
                    A <strong>Google Sign-In popup</strong> has opened in your browser. <br /><br />
                    If you don't see it, please check your <strong>taskbar</strong> or look behind your current browser window.<br /><br />
                    <span className="text-primary fw-medium">Once you sign in, this screen will automatically close.</span>
                </p>
                <div className="d-flex align-items-center justify-content-center gap-2 text-primary small">
                    <div className="spinner-border spinner-border-sm" role="status"></div>
                    <span>Waiting for Google Sign-In...</span>
                </div>
            </div>
        </div>
    );
};

export default GooglePopupOverlay;